import {
  MotionTooltipPosition,
  NormalizedMotionTooltipPosition,
} from './types';

export const DEFAULT_OFFSET = 8;

export const VIEWPORT_EDGE_PADDING = 8;

export const CLOSE_OVERLAY_DELAY_MS = 90;

export const TOUCH_AUTO_DISMISS_MS = 1000;

export const HOVER_NONE_MEDIA_QUERY = '(hover: none)';

export const OVERLAY_Z_INDEX_CLASS = 'z-[9999]';

export const PANEL_MOTION_TRANSITION = {
  duration: 0.16,
  ease: 'easeOut' as const,
};

export const DEFAULT_OVERLAY_CLASSNAME = '';

export const DEFAULT_PANEL_CLASSNAME = '';

export const DEFAULT_POSITION: MotionTooltipPosition = 'top-center';

export const DEFAULT_MODE = 'tooltip' as const;

export const DEFAULT_STAGGER_INDEX = 0;

export const triggerStaggerVariants = {
  visible: (index: number) => ({
    opacity: 1,
    x: 0,
    transition: {
      opacity: {
        duration: 0.38,
        delay: index * 0.07,
        ease: [0.22, 1, 0.36, 1],
      },
      x: {
        duration: 0.48,
        delay: index * 0.07,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  }),
  hidden: (index: number) => ({
    opacity: 0,
    x: 32,
    transition: {
      opacity: {
        duration: 0.26,
        delay: index * 0.05,
        ease: [0.4, 0, 1, 1],
      },
      x: {
        duration: 0.32,
        delay: index * 0.05,
        ease: [0.4, 0, 1, 1],
      },
    },
  }),
};

export const normalizePosition = (
  position: MotionTooltipPosition,
): NormalizedMotionTooltipPosition => {
  if (position === 'top' || position === 'top-center') return 'top-center';
  if (position === 'bottom' || position === 'bottom-center')
    return 'bottom-center';
  if (position === 'left' || position === 'left-center') return 'left-center';
  return 'right-center';
};
